export class Question {

    id = 0;
    question = "";
    options = "";

    constructor(id, question, options) {
        this.id = id
        this.question = question
        this.options = options
    }

}